module.exports = __webpack_public_path__ + "img/symbol_2.3f06a4ec.png";